/**
 * The characters a set code is drawn from: no two shapes a handwritten or
 * projected character can be read as one another. Mirrors
 * public.generate_question_set_code and the question_sets_code_check constraint.
 */
export const QUESTION_SET_CODE_ALPHABET = 'ACEFHJKMNPRTUWXY23456789';
export const QUESTION_SET_CODE_LENGTH = 6;
export const QUESTION_SET_CODE_PATTERN = new RegExp(
  `^[${QUESTION_SET_CODE_ALPHABET}]{${QUESTION_SET_CODE_LENGTH}}$`
);

/** The most questions one set may hold. The answer sheet has this many rows. */
export const QUESTION_SET_MAX_COUNT = 10;

/** The most sets one listing returns, and what a listing naming no limit gets. */
export const QUESTION_SET_QUERY_LIMIT = 200;

export const QUESTION_SET_MAX_TOPICS = 200;
export const QUESTION_SET_MAX_TOPIC_GROUPS = 50;
export const QUESTION_SET_MAX_QUESTION_TYPES = 20;
export const QUESTION_SET_MAX_DIRECTIVE_VERBS = 50;
export const QUESTION_SET_MAX_SOURCE_SETS = 20;

export const QUESTION_SET_BLUEPRINT_VERSION = 1;

const getAttributes = [
  'id',
  'code',
  'title',
  'description',
  'status',
  'blueprint',
  'randomSeed',
  'composedBy',
  'publishedBy',
  'publishedAt',
  'createdAt',
  'updatedAt',
] as const;

const listAttributes = ['id', 'code', 'title', 'status', 'blueprint', 'createdAt'] as const;

/** What a tutor may change after composing; everything else is the composition. */
const updateAttributes = ['title', 'description'] as const;

export const QuestionSetAttributes = {
  Get: getAttributes,
  List: listAttributes,
  Update: updateAttributes,
};
